import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {startGoogleAuthFlow} from 'app/utils/googleAuth';
import logEvent from 'app/amplitude/log_event';
import {pushAnalyticsEvent} from 'app/utils/analytics';

interface Props {
    redirectUrl?: string;
    usingOnTab?: string;
    getPromocode?: () => string | undefined;
}

export default class FastRegistrationSingWithGoogle extends PureComponent<Props> {
    handleClick = (): void => {
        const {redirectUrl, usingOnTab, getPromocode} = this.props;

        logEvent('JOIN_PAGE_LEAD', {
            SOURCE: usingOnTab,
            method: 'google'
        });
        pushAnalyticsEvent('registration_start', {
            method: 'google',
            placement: usingOnTab || 'registration_popup'
        });

        startGoogleAuthFlow({
            promocode: getPromocode?.(),
            redirectUrl
        });
    };

    render(): ReactNode {
        return (
            <button
                type="button"
                className="button-adaptive button-adaptive_gooogle"
                onClick={this.handleClick}
            >
                <SpriteIcon name="#svg-google-icon" className="svg-default" />
                <span>{I18n.t('sign_with_google')}</span>
            </button>
        );
    }
}
